
















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class SubMenu extends Vue {
  @Prop() menuInfo!: any | {};

  @Prop() isfirst!: string;
}
